/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-unknown-property */
import React, { useEffect, useState , Fragment } from 'react';
import PropTypes from 'prop-types';
import PageHeader from '../common/PageHeader';
import { Alert, Button, Card, CardBody, CardFooter, Col, Input, Row, Table } from 'reactstrap';
import { useSelector } from 'react-redux';
import FalconCardHeader from '../common/FalconCardHeader';
import ButtonIcon from '../common/ButtonIcon';
import handleErrorMessage from '../../helpers/errors/handleErrorMessage';
import { SUCCESS_RESPONSE } from '../../helpers/codeResponses/codes';
import withRedirect from '../../helpers/hoc/withRedirect';
import { Toast } from './../UI/toast/Toast';
import { faFileExcel, faInfoCircle, faPlus, faSearch } from '@fortawesome/free-solid-svg-icons';
import { deleteProvider, fetchProviders, fetchProvidersAsProperty } from '../../helpers/api/provider';
import useSWRFetchPagination from '../../helpers/hooks/useSWRFetchPagination'
import FullPagination from '../common/pagination/FullPagination';
import { isIterableArray } from '../../helpers/utils';
import ProviderListItem from '../common/ProviderListItem';
import { Message, Or, PreloadState } from '../UI/preloading/PreloadState';
import classNames from 'classnames';
import SupportLink from '../root/support/components/SupportLink';
import ImportPropertiesModal from '../properties/ImportPropertiesModal';

const Providers = ({ setRedirect, setRedirectUrl }) => {

    const { selectedCondominium } = useSelector(state => state.condominium);
    const { role } = useSelector(state => state.auth.user);
    const [textSearch, setTextSearch] = useState('');
    const [importModalOpen, setImportModalOpen] = useState(false);
    const [params, setParams] = useState({
        condominiumId: selectedCondominium,
        search: null,
    });

    useEffect(() => {
        setParams((prev) => (
            prev.condominiumId === selectedCondominium
                ? prev
                : { ...prev, condominiumId: selectedCondominium }
        ));
    }, [selectedCondominium]);

    const applyProviderSearch = (value = textSearch) => {
        const term = typeof value === 'string' ? value.trim() : '';
        setTextSearch(term);
        setParams((prev) => ({ ...prev, search: term || null }));
    };
    const {
        data,
        error,
        isLoading,
        meta,
        mutate,
        handler: { nextPage, previousPage, perPage, goToPage }
    } = useSWRFetchPagination(role === 'manager' ? fetchProviders : fetchProvidersAsProperty, params);

    const renderProvidersItems = () => {
        return data.map((provider, i) => {
            return <ProviderListItem 
                key={i}
                title={provider.name}
                description={provider.description}
                address={provider.address}
                email={provider.email}
                phone={provider.phone}
                dni={provider.dni}
                toDeleteId={provider.id}
                toEditId={provider.id}
                onDetailsAction={() => handleDatails(provider.id)}
                onDeleteAction={() => handleDelete(provider.id)}
                onEditAction={() => handleEdit(provider.id)}
                createdAt={provider.created_at}
                alternativeName="proveedor"
                options={role === 'manager'}
            />
        })
    }

    const handleEdit = async (provider) => {
        setRedirectUrl(`/dashboard/providers/edit/${provider}`);
        setRedirect(true);
    }

    const handleDatails = async (provider) => {
        setRedirectUrl(`/dashboard/providers/${selectedCondominium}/payments-provider/${provider}`);
        setRedirect(true);
    }

    const handleDelete = async (provider) => {
        try {
            const response = await deleteProvider(provider);
            if (response.code === SUCCESS_RESPONSE.OK) {
                Toast.fire({
                    type: 'success',
                    title: 'Se ha eliminado el proveedor satisfactoriamente.',
                });
                setRedirectUrl('/dashboard/providers');
                setRedirect(true);
            }
        } catch (error) { handleErrorMessage(error); }
    }

    return <>
        <PageHeader
            title={`Proveedores`}
            titleTag="h2"
            description={role === 'manager' ? "Gestiona los proveedores del condominio." : 'Visualiza los proveedores de tu condominio.'}
            className="mb-3"
            col={{ lg: 9 }}
        >
            <SupportLink />
        </PageHeader>
        <Card>
            <FalconCardHeader title='Proveedores'>
                <Row>
                    <Col xs={12} md={''} className="d-flex mb-2 mb-md-0">
                        <Input
                            type='text'
                            value={textSearch}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') applyProviderSearch(e.target.value);
                            }}
                            onChange={(event) => {
                                const value = event.target.value;
                                setTextSearch(value);
                                if (!value.trim()) {
                                    setParams((prev) => ({ ...prev, search: null }));
                                }
                            }}
                            placeholder="Buscar por nombre, cédula, teléfono, correo, descripción o dirección..."
                            className="d-inline-block search-input mr-2" />
                        <ButtonIcon icon={faSearch} className='d-inline-block text-nowrap' color='falcon-default' onClick={() => applyProviderSearch()} >Buscar</ButtonIcon>
                    </Col>
                    {role === 'manager' &&
                        <Col xs={'12'} md={'auto'} className='text-center'>
                            <ButtonIcon icon={faPlus} color='falcon-default' onClick={() => { setRedirect(true); setRedirectUrl(`/dashboard/providers/create`); }}>
                                Añadir proveedor
                            </ButtonIcon>
                            <ButtonIcon icon={faFileExcel} color='falcon-default' className='ml-2' onClick={() => setImportModalOpen(true)}>
                                Cargar archivo
                            </ButtonIcon>
                        </Col>}
                </Row>
            </FalconCardHeader>
            <CardBody className={isIterableArray(data) ? "p-0 fs--1" : 'fs--1'}>
                <PreloadState cond={isIterableArray(data)} loading={isLoading}>
                    <Table responsive striped >
                        <thead>
                            <tr>
                                <th weight='10%'>Nombre</th>
                                <th weight='50%' >Descripción</th>
                                <th>Correo electrónico</th>
                                <th >N° de teléfono</th>
                                {role === 'manager' && <th weight='10%' >Opciones</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {renderProvidersItems()}
                        </tbody>
                    </Table>
                    <Or value={false} cond={!!error}>
                        <Row value={false} className="p-card">
                            <Message className='p-2' icon={faInfoCircle} color={'info'}>
                                Al parecer aún no has creado un proveedor,
                                puedes crear uno ahora mismo pulsando el botón "Añadir proveedor"
                            </Message>
                        </Row>
                        <Row value={true} className="p-card">
                            <Col>
                                <Alert color="danger" className="mb-0">
                                    Esta página no está disponible
                                    <Button data-testid="Button" color="link" size="sm" className="ml-1 pl-0" onClick={() => { setRedirectUrl(`/dashboard/banks`); setRedirect(true) }}>
                                        Volver
                                    </Button>
                                </Alert>
                            </Col>
                        </Row>
                    </Or>
                </PreloadState>
            </CardBody>
            {isIterableArray(data) &&
                <CardFooter className='border-top'>
                    <FullPagination
                        nextPage={nextPage}
                        prevPage={previousPage}
                        goToPage={goToPage}
                        meta={meta}
                        className={'shadow-none'}
                        posText={"proveedores"}
                        perPage={perPage} />
                </CardFooter>
            }
        </Card>
        {role === 'manager' &&
            <ImportPropertiesModal
                isOpen={importModalOpen}
                toggle={() => setImportModalOpen(!importModalOpen)}
                importType="providers"
                selectedCondominium={selectedCondominium}
                onSuccess={() => mutate()}
            />}
    </>
}

Providers.propTypes = { location: PropTypes.object.isRequired };

export default withRedirect(Providers);